export default {
      id: "ic_weathers_snowly-usage",
      viewBox: "0 0 22 22",
      url: "/" + "images/icons.3.109.2.svg#ic_weathers_snowly-usage",
      toString: function () {
        return this.url;
      }
    }